var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShitcoinSniperBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 349 349",
    style: {
      enableBackground: "new 0 0 349 349"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F42CFF;}\n\t.st1{fill:#EE746C;}\n\t.st2{fill:#FB9761;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1020.36)",
    imageRendering: "auto",
    shapeRendering: "auto",
    colorRendering: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.5,1057.7c-75.7,0-137.1,61.5-137.1,137.1c0,75.7,61.5,137.1,137.1,137.1s137.2-61.5,137.2-137.1 S250.1,1057.7,174.5,1057.7L174.5,1057.7z M174.5,1070.1c68.9,0,124.7,55.8,124.7,124.7c0,68.9-55.8,124.7-124.7,124.7 s-124.6-55.8-124.6-124.7C49.9,1125.9,105.6,1070.1,174.5,1070.1L174.5,1070.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.5,1164.8c-16.5,0-30,13.5-30,30c0,16.5,13.5,30,30,30s30-13.5,30-30S191,1164.8,174.5,1164.8 L174.5,1164.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.3,1020.4v112.2h12.4v-112.2L168.3,1020.4L168.3,1020.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.3,1257.1v112.3h12.4v-112.3H168.3L168.3,1257.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236.9,1188.6v12.5H349v-12.5H236.9L236.9,1188.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,1188.6v12.5h112.2v-12.5H0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.5,1179.9c8.4,0,15.1,6.6,15.1,14.9c0,8.4-6.7,15.1-15.1,15.1c-8.4,0-14.9-6.7-14.9-15.1 S166.1,1179.9,174.5,1179.9L174.5,1179.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M174.5,1185.5c5.2,0,9.4,4.1,9.4,9.4c0,5.2-4.2,9.4-9.4,9.4s-9.4-4.2-9.4-9.4 C165.1,1189.6,169.2,1185.5,174.5,1185.5L174.5,1185.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.9,1097.7c-3.4,0.2-6.1,3.1-5.9,6.5c0.1,2.8,2.1,5.1,4.8,5.7c31.9,7.6,56.9,32.6,64.5,64.5 c0.8,3.4,4.2,5.4,7.5,4.6c3.4-0.8,5.4-4.2,4.6-7.5l0,0c-8.8-36.5-37.3-65-73.8-73.7C197.1,1097.7,196.5,1097.6,195.9,1097.7 L195.9,1097.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.9,1097.7c-0.6,0-1.1,0.1-1.7,0.2c-36.4,8.7-64.9,37.1-73.7,73.5c-0.9,3.3,1.1,6.7,4.4,7.6 s6.7-1.1,7.6-4.4c0-0.1,0-0.2,0.1-0.3c7.7-31.9,32.6-56.7,64.4-64.4c3.4-0.8,5.4-4.1,4.7-7.5 C158.2,1099.7,155.7,1097.8,152.9,1097.7L152.9,1097.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M265.6,1210.5c-3-0.1-5.6,2-6.2,4.8c-7.7,31.9-32.6,56.7-64.4,64.4c-3.4,0.7-5.6,4-4.9,7.3 c0.7,3.4,4,5.6,7.3,4.9c0.2,0,0.3-0.1,0.5-0.1c36.4-8.7,64.9-37.2,73.7-73.6c0.9-3.3-1.1-6.7-4.5-7.6 C266.5,1210.5,266.1,1210.5,265.6,1210.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.2,1210.3c-3.4,0.2-6.1,3.1-5.9,6.5c0,0.4,0.1,0.8,0.2,1.2c8.7,36.5,37.2,65,73.7,73.8 c3.3,0.8,6.7-1.3,7.5-4.6c0.8-3.3-1.3-6.7-4.6-7.5l0,0c-31.9-7.7-56.8-32.6-64.4-64.5C89,1212.2,86.3,1210.1,83.2,1210.3 L83.2,1210.3L83.2,1210.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShitcoinSniperBadge);
export default __webpack_public_path__ + "static/media/shitcoin_sniper_badge.43eef7bdf38b92ecb78ac8c62d649202.svg";
export { ForwardRef as ReactComponent };